import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { LoaderService } from '@/shared/services/loader.service';
import { CourseService } from '@/features/course/course/course.service';
import { environment } from '@env/environment';
import { ProgressBar } from 'primeng/progressbar';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, Toast, ConfirmDialog, ProgressBar],
    template: `
        <p-toast position="bottom-right"></p-toast>
        <p-confirmDialog
            header="Confirmation"
            [baseZIndex]="10000"
            icon="pi pi-exclamation-triangle"
            [style]="{ width: '30rem' }"
            [breakpoints]="{ '640px': 'calc(100vw - 2rem)' }"
            styleClass="app-confirm-dialog"
        ></p-confirmDialog>
        @if (loaderService.isLoading()) {
            <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
        }
        <router-outlet></router-outlet>
    `,
    styles: [`
        :host ::ng-deep .app-confirm-dialog {
            border-radius: 1.25rem;
        }

        :host ::ng-deep .app-confirm-dialog .p-dialog-header {
            padding: 1.5rem 1.5rem 0.75rem;
        }

        :host ::ng-deep .app-confirm-dialog .p-dialog-content {
            padding: 0 1.5rem 1rem;
        }

        :host ::ng-deep .app-confirm-dialog .p-dialog-footer {
            display: flex;
            justify-content: flex-end;
            gap: 0.75rem;
            padding: 0 1.5rem 1.5rem;
        }

        :host ::ng-deep .app-confirm-dialog .p-confirmdialog-message {
            line-height: 1.5;
        }

        :host ::ng-deep .app-confirm-dialog .p-button {
            min-width: 5.5rem;
        }
    `]
})
export class AppComponent {
    constructor(
        public loaderService: LoaderService,
        private router: Router,
        private courseService: CourseService
    ) {
        void this.courseService.lazyLoadSelectItems();

        if (environment.logging.router) {
            this.router.events.subscribe((event) => {
                console.log(event);
            });
        }
    }
}
